import { apiPost } from "../baseApi";

export const loginVerify = async (data) => {
  try {
    const response = await apiPost("_loginVerify", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
